import React, { useEffect, useState } from "react";
import MUIDataTable from "mui-datatables";
import MaterialTable from "material-table";
import DataService from "./../../../../Service";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import Tooltip from "@material-ui/core/Tooltip";
import IconButton from "@material-ui/core/IconButton";
import CircularProgress from "@material-ui/core/CircularProgress";
import { createMuiTheme } from "@material-ui/core/styles";
import HeaderMenu from "./../../../../Components/HeaderMenu";
import useDebounce from "./../../../../Components/debounce";
import { useHistory, useLocation } from "react-router";
import { AddCircleOutlined } from "@material-ui/icons";
import Typography from "@material-ui/core/Typography";
import Loader from "./../../../../Components/Loader";
import { useParams } from "react-router-dom";
import SaveAlt from "@material-ui/icons/SaveAlt";
import { forwardRef } from "react";
import { useDispatch } from "react-redux";
import makeStyles from "@material-ui/core/styles/makeStyles";
import InputBase from "@material-ui/core/InputBase";
import InputAdornment from "@material-ui/core/InputAdornment";
import SearchIcon from "@material-ui/icons/Search";
import { DELETE_STEPPER_DATA } from "./../../../../Redux/actions";
import { ResetWorkInformation } from "./Create/WorkInformation/WorkInformationActions";
import { ResetTrainingAndDevelopment } from "./Create/TrainingAndDevelopment/TrainingAndDevelopmentActions";
import { ResetMentorProfile } from "./Create/MentorProfile/MentorProfileActions";
import { ResetMentoringCapacity } from "./Create/MentoringCapacity/MentoringCapatityActions";
import { ResetGdpr } from "./Create/Gdpr/GdprActions";
import { ResetFacilitation } from "./Create/Facilitation/FacilitationActions";
import { ResetContactArea } from "./Create/ContactArea/ContactAreaActions";
import { ResetCoachingProfile } from "./Create/CoachingProfile/CoachingProfileActions";
import { ResetCoachingCapacity } from "./Create/CoachingCapacity/CoachingCapatityActions";
import { ResetAccessment } from "./Create/Accessment/AccessmentActions";
import { useSelector } from "react-redux";
import { TooltipWrapper } from "../../../../Common/Utils/common_utils";
import { showSnackbar } from "../../../../Components/Snackbar/SnackbarActions";
import ExportSelector from "../../Organization/ManageInfo/ExportSelector";

export default function EmployeeList(props) {
  const history = useHistory();
  const dispatch = useDispatch();
  const location = useLocation();
  const globaluserData = useSelector((state) => state.commonReducer);

  const disableViewIcon = useSelector((state) => state.commonReducer)
    ?.accessPermission?.assignmentDetail?.employee?.disableViewIcon;

  const disableAddButton = useSelector((state) => state.commonReducer)
    ?.accessPermission?.assignmentDetail?.employee?.disableAddButton;
  const role = globaluserData?.role;
  const createOrganisationListLayout = {
    width: "90%",
    margin: "0 auto",
  };
  const nameFinder = (specificRowData, specificUserData) => {
    const existingData = specificUserData.find((item) => {
      return (
        item.id !== specificRowData.id &&
        item?.first_name?.trim()?.toLowerCase() ===
          specificRowData?.first_name?.trim()?.toLowerCase() &&
        item?.last_name?.trim()?.toLowerCase() ===
          specificRowData?.last_name?.trim()?.toLowerCase()
      );
    });
    return existingData
      ? `${specificRowData.first_name} ${specificRowData.middle_name || ""} ${
          specificRowData.last_name
        }`
      : `${specificRowData.first_name} ${specificRowData.last_name}`;
  };
  const useStyles = makeStyles((theme) => ({
    rotateLink: {
      transform: "rotate(-26deg)",
    },
    wrapper: {
      backgroundColor: "#fff",
      borderRadius: "4px",
      padding: theme.spacing(1, 2),
      border: "1px solid #d5d5d5",
      marginLeft: "56px",
      marginBottom: "30px",
      paddingLeft: "2px",
      paddingTop: "3px",
      paddingBottom: "8px",
      width: "32%",
      height: "40px",
    },
    divider: {
      margin: "8px 0",
    },
    filters: {
      padding: "10px 24px",
      "& .filter": {
        paddingRight: theme.spacing(3),
      },
    },
    miTable: {
      "& .MuiToolbar-root": {
        "& .material-icons": {
          color: theme.palette.secondary.main,
        },
      },
      "& .MuiTableHead-root": {
        "& .MuiTableCell-head": {
          "& span": {
            color: "#077F83",
          },
        },
      },
      "& .MuiTableBody-root": {
        "& .MuiTableCell-body": {
          padding: "10px 16px",
          lineHeight: "1.50",
          color: "#4A4A4A !important",
          "& .MuiIconButton-root": {
            padding: "0px 16px",
          },
        },
      },
    },
  }));
  // const theme = createMuiTheme({
  //   overrides: {
  //     MUIDataTablePagination: {
  //       tableCellContainer: {
  //         padding: "0px",
  //       },
  //       navContainer: {
  //         backgroundColor: "#f1eded",
  //       },
  //     },
  //     MUIDataTableHeadCell: {
  //       fixedHeader: {
  //         backgroundColor: "#f1eded",
  //       },
  //     },

  //   },
  // });
  const classes = useStyles();
  const [apiData, setApiData] = useState([]);
  const [loading, setLoading] = useState(false);
  let { id } = useParams();
  const [totalCount, setTotalCount] = useState(100);
  const [searchText, setSearchText] = useState("");
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(20);
  const [searchTextSelect, handleSearchText] = useState(null);
  const debouncedSearchText = useDebounce(searchTextSelect, 700);

  useEffect(() => {
    setLoading(true);
    getData();
  }, [page, pageSize, debouncedSearchText, props.organisation]);

  const getData = () => {
    const params = {
      page: page + 1 || 1,
      count_per_page: pageSize || 20,
      search_keyword: debouncedSearchText || null,
      organisation_id: id,
    };
    DataService.getDirectData(`/employees`, params)
      .then((response) => {
        let listData = response["employees"];
        setApiData(listData);
        setTotalCount(response.total_count);
        setLoading(false);
      })

      .catch((err) => {});
  };

  const columns = [
    {
      field: "id",
      title: "ID",
      export: true,
      hidden: true,
      notExportable: true,
    },
    {
      field: "full_name",
      title: "Name",
      headerStyle: {
        textAlign: "left",
        padding: "10px 26px",
        color: " #EF7000",
      },
      cellStyle: {
        textAlign: "left",
        padding: "10px 26px",
      },
      render: (rowData) => {
        return nameFinder(rowData, apiData);
      },
    },
    // {
    //   field: "primary_email",
    //   title: "Primary email",
    //   headerStyle: {
    //     display: "none",
    //   },
    //   cellStyle: {
    //     display: "none",
    //   },
    // },
    {
      field: "organisation_name",
      title: "",
      headerStyle: {
        display: "none",
      },
      cellStyle: {
        display: "none",
      },
    },

    {
      title: !disableViewIcon && "Actions",
      notExportable: true,
      headerStyle: {
        textAlign: "right",
        padding: "10px 26px",
        color: " #EF7000",
      },
      cellStyle: {
        textAlign: "right",
        paddingRight: "40px",
      },

      render: (rowData) =>
        !disableViewIcon && (
          <Button
            disableElevation
            variant="outlined"
            color="#F1ECED"
            size="small"
            onClick={() => {
              history.push({
                pathname: `/admin/organisation/${id}/employee/${rowData.id}/edit`,
                state: { orgName: rowData.organisation_name },
              });
            }}
            style={{
              backgroundColor: "#008080",
              color: "#fff",
              textTransform: "none",
            }}
          >
            View
          </Button>
        ),
    },
    {
      notExportable: true,
      id: "download_individual",
      render: (rowData) => {
        return (
          <Tooltip
            title={
              <TooltipWrapper
                text={
                  isDownloadIndividual.isLoading &&
                  isDownloadIndividual.downloadingOption === rowData.id
                    ? `Downloading ${
                        nameFinder(rowData, apiData) || ""
                      } records`
                    : `Download ${nameFinder(rowData, apiData) || ""} records`
                }
              />
            }
          >
            <IconButton
              onClick={(event) => {
                handleDownloadIndividual(rowData);
              }}
              disabled={
                isDownloadIndividual.isLoading &&
                isDownloadIndividual.downloadingOption !== rowData.id
              }
            >
              {isDownloadIndividual.isLoading &&
              isDownloadIndividual.downloadingOption === rowData.id ? (
                <CircularProgress size={20} color="secondary" />
              ) : (
                <SaveAlt style={{ height: "01.5rem" }} color="secondary" />
              )}
            </IconButton>
          </Tooltip>
        );
      },
    },
  ].filter((el) => {
    if (role === "employee") {
      if (el.id === "download_individual") {
        return false;
      }
      return true;
    }
    return true;
  });

  const options = {
    exportButton: false,
    search: false,
    exportFileName: "organisation_list",
    emptyRowsWhenPaging: false,
    exportDelimiter: ",",
    searchFieldAlignment: "right",
    total: totalCount,
    exportAllData: true,
    headerStyle: {
      fontWeight: "800",
    },
    page: page,
    pageSize: pageSize,
  };
  // const tableIcons = {
  //   Export: forwardRef((props, ref) => <SaveAlt style={{ paddingRight: '45px', color: "#EF7000" }}  {...props} ref={ref} />),
  // };
  const tableIcons = {
    Export: forwardRef((props, ref) => (
      <SaveAlt style={{ color: "#EF7000" }} {...props} ref={ref} />
    )),
  };
  // Downloading logic
  const [isDownloadAllLoading, setIsDownloadAllLoading] = useState(false);
  const [isDownloadIndividual, setIsDownloadIndividual] = useState({
    isLoading: false,
    downloadingOption: "",
  });
  const handleDownloadAll = (event) => {
    setIsDownloadAllLoading(true);
    const params = {
      organisation_id: id,
    };
    DataService.getDirectData("employees/employees_data_download", params)
      .then((res) => {
        window.location.assign(res.file);
        dispatch(showSnackbar("success", ["Downloaded successfully "]));
      })
      .catch((error) => {
        dispatch(showSnackbar("error", ["No data found!"]));
      })
      .finally(() => {
        setIsDownloadAllLoading(false);
      });
  };
  const handleDownloadIndividual = (option) => {
    console.log(option, "options");
    const { id: optionId, full_name: optionName } = option;
    setIsDownloadIndividual({
      isLoading: true,
      downloadingOption: optionId,
    });
    const params = { employee_id: optionId, organisation_id: id };
    DataService.getDirectData("employees/employees_data_download", params)
      .then((res) => {
        window.location.assign(res.file);
        dispatch(
          showSnackbar("success", ["Downloaded successfully " + optionName])
        );
      })
      .catch((error) => {
        dispatch(showSnackbar("error", ["No data found!"]));
      })
      .finally(() => {
        setIsDownloadIndividual({ isLoading: false, downloadingOption: "" });
      });
  };
  return (
    <React.Fragment>
      {/* <HeaderMenu /> */}
      <Grid
        container
        direction="row"
        justify="center"
        alignItems="center"
        style={{
          paddingTop: 30,
          paddingBottom: 30,
          paddingLeft: 80,
          paddingRight: 80,
        }}
      >
        <Grid item xs={6} style={{ textAlign: "left" }}>
          <Typography
            variant="h1"
            color="primary"
            style={{
              lineHeight: "30px",
              fontWeight: "bold",
              marginLeft: "-19px",
            }}
          >
            All employees
          </Typography>
        </Grid>
        <Grid item xs={6} style={{ textAlign: "right" }}>
          {!disableAddButton && (
            <Button
              disableElevation
              variant="contained"
              color="secondary"
              onClick={() => {
                dispatch({ type: DELETE_STEPPER_DATA });
                dispatch(ResetAccessment());
                dispatch(ResetCoachingCapacity());
                dispatch(ResetCoachingProfile());
                dispatch(ResetContactArea());
                dispatch(ResetFacilitation());
                dispatch(ResetGdpr());
                dispatch(ResetMentoringCapacity());
                dispatch(ResetMentorProfile());
                dispatch(ResetTrainingAndDevelopment());
                dispatch(ResetWorkInformation());
                history.push({
                  pathname: `/admin/organisation/${id}/employee/create`,
                  state: { orgName: location?.state?.orgName },
                });
              }}
              style={{ textTransform: "none" }}
            >
              <AddCircleOutlined style={{ marginRight: 10, fontSize: 15 }} />
              Create employee
            </Button>
          )}
        </Grid>
      </Grid>
      <div className={classes.wrapper}>
        <InputBase
          fullWidth
          style={{
            height: 50,
            paddingLeft: 10,
            fontSize: "16px",
            fontFamily: "Open Sans",
          }}
          placeholder={"Search anything"}
          value={searchTextSelect}
          onChange={(e) => handleSearchText(e.target.value)}
          startAdornment={
            <InputAdornment position="start">
              <SearchIcon />
            </InputAdornment>
          }
        />
      </div>
      <div style={createOrganisationListLayout}>
        <Grid xs={12} sm={8}>
          {loading && <Loader />}
          <MaterialTable
            title={
              <Typography variant="subtitle1" style={{ color: "#EF7000" }}>
                Employees
              </Typography>
            }
            icons={tableIcons}
            data={apiData}
            columns={columns}
            options={options}
            totalCount={totalCount}
            page={page}
            onChangePage={(page) => {
              setPage(page);
            }}
            onChangeRowsPerPage={(pageSize) => {
              setPageSize(pageSize);
            }}
            onSearchChange={(search) => {
              setSearchText(search);
            }}
            actions={[
              !disableViewIcon && {
                icon: () => {
                  const params = {
                    count_per_page: totalCount || 20,
                    search_keyword: debouncedSearchText || null,
                    organisation_id: id,
                    page: 1,
                  };
                  let url = "/employees";
                  return (
                    <ExportSelector
                      params={params}
                      columns={columns}
                      url={url}
                      downloadKey="employees"
                      fileName={"Employee list"}
                      downloadText={"Download employees listing"}
                      downloadingText={"Downloading employees listing"}
                    />
                  );
                },
                isFreeAction: true,
              },
              !disableViewIcon && {
                icon: (event, rowData) => {
                  return (
                    <Tooltip
                      title={
                        <TooltipWrapper
                          text={
                            isDownloadAllLoading
                              ? `Downloading all records`
                              : `Download all records`
                          }
                        />
                      }
                    >
                      {isDownloadAllLoading ? (
                        <CircularProgress size={20} color="secondary" />
                      ) : (
                        <SaveAlt
                          style={{ height: "01.5rem" }}
                          color="secondary"
                        />
                      )}
                    </Tooltip>
                  );
                },
                isFreeAction: true,
                onClick: handleDownloadAll,
              },
            ]}
            localization={{
              toolbar: {
                exportName: "Export as CSV",
                exportAriaLabel: "Export as CSV",
                exportTitle: <TooltipWrapper text="Export as CSV" />,
              },
            }}
          />
        </Grid>
      </div>
    </React.Fragment>
  );
}
